"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSurveyMarketResponseToJSON = exports.GetSurveyMarketResponseFromJSONTyped = exports.GetSurveyMarketResponseFromJSON = exports.instanceOfGetSurveyMarketResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GetSurveyMarketResponse interface.
 */
function instanceOfGetSurveyMarketResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetSurveyMarketResponse = instanceOfGetSurveyMarketResponse;
function GetSurveyMarketResponseFromJSON(json) {
    return GetSurveyMarketResponseFromJSONTyped(json, false);
}
exports.GetSurveyMarketResponseFromJSON = GetSurveyMarketResponseFromJSON;
function GetSurveyMarketResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyMarketId': !(0, runtime_1.exists)(json, 'survey_market_id') ? undefined : json['survey_market_id'],
    };
}
exports.GetSurveyMarketResponseFromJSONTyped = GetSurveyMarketResponseFromJSONTyped;
function GetSurveyMarketResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_market_id': value.surveyMarketId,
    };
}
exports.GetSurveyMarketResponseToJSON = GetSurveyMarketResponseToJSON;
